import { frame as s } from "./atoms-v2949.js";
import { makeUseVisualState as u } from "./atoms-v2994.js";
import { transformProps as d } from "./atoms-v2932.js";
import { buildSVGAttrs as p } from "./atoms-v21191.js";
import { createSvgRenderState as c } from "./atoms-v21263.js";
import { isSVGTag as h } from "./atoms-v21193.js";
import { renderSVG as l } from "./atoms-v21194.js";
import { scrapeMotionValuesFromProps as y } from "./atoms-v21195.js";
function V(o, t) {
  try {
    t.dimensions = typeof o.getBBox == "function" ? o.getBBox() : o.getBoundingClientRect();
  } catch {
    t.dimensions = {
      x: 0,
      y: 0,
      width: 0,
      height: 0
    };
  }
}
const g = ["x", "y", "width", "height", "cx", "cy", "r"], b = {
  useVisualState: u({
    scrapeMotionValuesFromProps: y,
    createRenderState: c,
    onUpdate: ({ props: o, prevProps: t, current: e, renderState: i, latestValues: f }) => {
      if (!e)
        return;
      let m = !!o.drag;
      if (!m) {
        for (const r in f)
          if (d.has(r)) {
            m = !0;
            break;
          }
      }
      if (!m)
        return;
      let n = !t;
      if (t)
        for (let r = 0; r < g.length; r++) {
          const a = g[r];
          o[a] !== t[a] && (n = !0);
        }
      n && s.read(() => {
        V(e, i), s.render(() => {
          p(i, f, h(e.tagName), o.transformTemplate), l(e, i);
        });
      });
    }
  })
};
export {
  b as svgMotionConfig
};
